export default __webpack_public_path__ + "static/media/upload.4566126a.svg";